import ClientModel                    from './ClientModel';
import DeliverableModel               from '@/models/services/shop/DeliverableModel';
import DeliverableTransferStatusModel from '@/models/services/shop/DeliverableTransferStatusModel';
import DeliverableTransferTypeModel   from '@/models/services/shop/DeliverableTransferTypeModel';
import ShopServiceModel               from '@/models/ShopServiceModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';
import TimestampAble                  from '@widesk-core/models/traits/TimestampAble';
import ProductVariantModel            from './ProductVariantModel';

@model.urnResource('deliverable_transfer')
@doc.path('/deliverable_transfers/{?id}')
export default class DeliverableTransferModel extends TimestampAble(ShopServiceModel) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'deliverable': id;
		'deliverableTransferStatus': id;
		'currentOwner.userUrn': Urn;
		'nextOwner.userUrn': Urn;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(ClientModel) declare currentOwner: ClientModel;
	@doc.model(DeliverableModel) declare deliverable: DeliverableModel;
	@doc.model(DeliverableTransferStatusModel) declare deliverableTransferStatus: DeliverableTransferStatusModel;
	@doc.model(DeliverableTransferTypeModel) declare deliverableTransferType: DeliverableTransferTypeModel;
	@doc.string declare email: string;
	@doc.model(ClientModel) declare nextOwner: ClientModel;
	@doc.model(ProductVariantModel) declare productVariant: ProductVariantModel;
}